import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout/MainLayout.vue'

Vue.use(Router)

const routes = [
  { path: '/login', component: () => import('@/views/Login.vue'), hidden: true },
  {
    path: '/',
    component: Layout,
    redirect: '/student',
    children: [
      { path: 'student', name: 'Student', meta: { title: '学员管理' }, component: () => import('@/views/student/List.vue') },
      { path: 'radar-dimension', name: 'RadarDimension', meta: { title: '列表维护' }, component: () => import('@/views/radar-dimension/List.vue') },
      { path: 'score-range', name: 'ScoreRange', meta: { title: '成绩区间' }, component: () => import('@/views/score-range/List.vue') },
      {
        path: 'age-range-fields',
        name: 'AgeRangeFields',
        meta: { title: '分段栏位查询' },
        component: () => import('@/views/age-range-fields/Query.vue')
      },
      { path: 'height-standard', name: 'HeightStandard', meta: { title: '身高标准' }, component: () => import('@/views/height-standard/List.vue') }
    ]
  }
]

const router = new Router({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next()
    return
  }
  if (!sessionStorage.getItem('Admin-Token')) {
    next('/login')
    return
  }
  next()
})

export default router
